module.exports = __webpack_public_path__ + "static/services-text-262c4f9f829578ae33fe709b805cb473.svg";